<section class="px-4 py-20">
  <app-galaxy-card padding="lg" class="max-w-3xl mx-auto text-center animate-fade-slide-up">
    <div galaxy-card-content>
      <h2 class="text-3xl sm:text-4xl font-bold mb-4 text-gray-100">
        ¿Listo para descubrir tu próxima fragancia icónica?
      </h2>
  
      <p class="text-gray-300 text-lg sm:text-xl mb-8">
        En Altair Parfum te acercamos la alta perfumería árabe y los mejores dupes de lujo original. Calidad excepcional, elegancia y estela inigualable a tu alcance.
      </p>
  
      <a routerLink="/tienda"
         appGalaxyButton
         appGalaxyRipple
         galaxyVariant="primary"
         galaxySize="lg"
         class="animate-pulse">
        Explorar Colección
      </a>
    </div>
  </app-galaxy-card>
</section>
